import React, { createContext, useReducer } from "react";
import { useNavigate } from "react-router-dom";
import * as Context from "../";
import { fetchRequest } from "../fetch";
import { API_URL, SERVICE_URL } from "../../utils";

const initialState = {
  islogin: !!JSON.parse(localStorage.getItem("auth")),
  _auth: JSON.parse(localStorage.getItem("auth")),
  products: [],
  notification: false,
  lang: "mn",
  filter: undefined,
  saleList: [],
  order: {},
  errorMsg: "",
  isOpenError: false,
  isLicenseModal: false,
  guideContent: [],
};

const models = {};

// API URL
const service = `${API_URL}api`;

// Local deer suusan service url
const service_url = `${SERVICE_URL}api`;

export const GlobalContext = createContext(initialState);

export const GlobalProvider = (props) => {
  const [state, dispatch] = useReducer(Context.appReducer, initialState);

  const addmodel = ({ model }) => {
    models[model] = {
      request: `request_${model}`,
      response: `response_${model}`,
      error: `error_${model}`,
    };
  };
  const navigate = useNavigate();
  const request = async ({
    url,
    model,
    body,
    method = "GET",
    isfile,
    isservice,
    ispaymentservice,
  }) => {
    try {
      if (isfile && body) {
        let formData = new FormData();
        Object.keys(body).map((keyname) => {
          if (Array.isArray(body[keyname])) {
            body[keyname].map((item) => {
              if (Object.keys(item).length > 0) {
                formData.append(keyname, JSON.stringify(item));
              } else {
                formData.append(keyname, item);
              }
            });
          } else {
            if (!keyname.includes("prev"))
              formData.append(keyname, body[keyname] ? body[keyname] : null);
          }
          return null;
        });
        body = formData;
      }

      if (model) {
        addmodel({ model: model });
      }

      const res = await fetchRequest({
        url: `${isservice ? `${service_url}${url}` : `${service}${url}`}`,
        method,
        body,
        isservice,
        ispaymentservice,
        model: model ? models[model] : null,
        dispatchEvent: dispatch,
        isfile: isfile,
      });
      if (res.status === 401) {
        localStorage.removeItem("auth");
        localStorage.removeItem("access_token");
        setlogin(false);
        navigate("/login");
      }
      /* notification: notification, */
      return res;
    } catch (error) {
      console.log("%c 🍬 error: ", error);
    }
  };

  const setlogin = (login) => dispatch({ type: "login", response: login });
  const setProducts = (data) => dispatch({ type: "products", response: data });
  const setFilter = (data) => dispatch({ type: "filter", response: data });
  const addSaleList = (data) =>
    dispatch({ type: "addSaleList", response: data });
  const removeSaleList = (data) =>
    dispatch({ type: "removeSaleList", response: data });
  const setOrderDetail = (data) =>
    dispatch({ type: "setOrderDetail", response: data });
  const setError = (data) => dispatch({ type: "setError", response: data });
  const setGuide = (data) => dispatch({ type: "setGuide", response: data });

  const setNotification = (value) => {
    if (state.resbanners && state.resbanners.length > 0)
      dispatch({ type: "notification", response: value });
  };

  return (
    <React.Fragment>
      <GlobalContext.Provider
        value={{
          ...state,
          request: request,
          setlogin,
          setProducts,
          setFilter,
          addSaleList,
          removeSaleList,
          setOrderDetail,
          setNotification,
          setError,
          setGuide,
        }}
      >
        {props.children}
      </GlobalContext.Provider>
    </React.Fragment>
  );
};
